import { Icon, Tooltip, TooltipContent, TooltipTrigger, cn } from "@nexus/ui";

export interface CriterionLabelProps {
  name: string;
  /** Catalogue definition surfaced on hover; without one the name renders plainly. */
  definition: string | null;
  /** Classes for the text element (caller controls colour/weight per context). */
  className?: string;
}

/**
 * Criterion name with an info affordance that reveals its catalogue definition on hover.
 * Shared by the breakdown table, the heatmap rows, and the top-blockers list so the
 * definition tooltip reads the same everywhere. Callers must provide a `TooltipProvider`.
 */
export function CriterionLabel({
  name,
  definition,
  className,
}: CriterionLabelProps) {
  if (!definition) {
    return <span className={cn("truncate", className)}>{name}</span>;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            "inline-flex min-w-0 cursor-help items-center gap-1",
            className,
          )}
        >
          <span className="truncate">{name}</span>
          <Icon
            name="info"
            size="xs"
            className="text-muted-foreground shrink-0"
            aria-hidden
          />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" align="start" className="max-w-xs">
        {definition}
      </TooltipContent>
    </Tooltip>
  );
}
